import CtaBlock, { type CtaContext } from "@/components/shared/CtaBlock";

interface SectionCtaProps {
  prefix?: string;
  to?: string;
  headline?: string;
  buttonLabel?: string;
  reassurance?: string;
  /** Tracking position label */
  position: string;
  product?: string;
  accentColor?: string;
  className?: string;
  context?: CtaContext;
  cityName?: string;
}

const SectionCta = ({
  prefix = "",
  to = "/jetzt-anfragen",
  headline,
  buttonLabel,
  reassurance,
  position,
  product,
  accentColor,
  className = "",
  context = "default",
  cityName,
}: SectionCtaProps) => {
  return (
    <CtaBlock
      variant="mid"
      context={context}
      cityName={cityName}
      prefix={prefix}
      to={to}
      headline={headline}
      subline={reassurance}
      buttonLabel={buttonLabel}
      trackingButton="mid_cta"
      className={className}
    />
  );
};

export default SectionCta;
